import script from "./NoCurrentlyReadingDocsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoCurrentlyReadingDocsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NoCurrentlyReadingDocsBlock.vue?vue&type=style&index=0&id=142b94aa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142b94aa"]])

export default __exports__